import { Col, Row } from "antd";
import Blinstabart from "./DashboardContent/Blinstabart";
import Calendar from "./DashboardContent/Calendar";
import Responsibilities from "./DashboardContent/Responsibilities/Responsibilities";
import EventsTable from "./DashboardContent/EventsTable/EventsTable";

const AdminDashboard = () => {
  return (
    <>
      <Row gutter={[0, 12]}>
        <Col span={24}>
          <Blinstabart />
        </Col>
        <Col span={24}>
          <Responsibilities />
        </Col>
        <Col span={24}>
          <EventsTable />
        </Col>
        <Col span={24}>
          <Calendar />
        </Col>
      </Row>
    </>
  );
};

export default AdminDashboard;
